import TimeAgo from 'javascript-time-ago'
import LanguageIcon from 'src/assets/icons/language-icon.svg'

import { useState } from 'react'
import { locales } from './data'
import { useTranslation } from 'react-i18next'
import { DownOutlined } from '@ant-design/icons'
import { localStorageGetItem } from 'src/utils/storage'
import { timeAgoLocales } from 'src/locales/time-ago-locales'
import { Button, Dropdown, MenuProps, Typography } from 'antd'

function LanguageSelector() {
  const { i18n } = useTranslation()
  const [isOpened, setIsOpened] = useState(false)
  const lng = localStorageGetItem('i18nextLng', 'en-GB')

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    i18n.changeLanguage(e.key)
    TimeAgo.addLocale(timeAgoLocales[lng as keyof typeof timeAgoLocales])
  }

  const menuProps = {
    onClick: handleMenuClick,
    items: locales,
  }

  const currentLocale = locales.find((el) => el.key === lng)

  return (
    <Dropdown menu={menuProps} onOpenChange={(state) => setIsOpened(state)}>
      <Button size="large" data-testid="language-selector">
        {currentLocale?.icon ?? <LanguageIcon />}
        <Typography.Text ellipsis className="w-[115px]">
          {isOpened
            ? i18n.t('languageSelector.select')
            : (currentLocale?.label ?? i18n.t('languageSelector.change'))}
        </Typography.Text>
        <DownOutlined />
      </Button>
    </Dropdown>
  )
}

export default LanguageSelector
